module.exports = "<jujo_component specialized=\"false\" comp=\"jujo_grid\" c_key=\"products_list\" entity=\"product\"></jujo_component>"